import history from 'utils/browserHistory';

export function analyticsInit() {
  history.push('/analytics/dashboards');
}
